import { loadChiliPiperScript } from "./chiliPiperScriptLoader";

const CHILI_PIPER_DOMAIN = "circle-co";

export const CHILI_PIPER_ROUTERS = {
  IN_APP_PLUS_BUTTON: "in-app-plus-button",
  IN_APP_PLUS_PAGE: "in-app---plus-page",
} as const;

export const CHILI_PIPER_TRIGGERS = {
  IN_APP_BUTTON: "InAppButton",
} as const;

export interface ChiliPiperConfig {
  lead: Record<string, unknown>;
  router: string;
  trigger: string;
}

export const triggerChiliPiper = async (
  config: ChiliPiperConfig,
): Promise<void> => {
  try {
    await loadChiliPiperScript();

    if (window.ChiliPiper) {
      window.ChiliPiper.submit(CHILI_PIPER_DOMAIN, config.router, {
        trigger: config.trigger,
        lead: config.lead,
      });
    }
  } catch (error) {
    console.error("Failed to load or trigger ChiliPiper:", error);
  }
};

export const triggerChiliPiperForPlusButton = async (
  email: string,
  firstName: string,
  lastName: string,
): Promise<void> =>
  triggerChiliPiper({
    lead: { email, "First Name": firstName, "Last Name": lastName },
    router: CHILI_PIPER_ROUTERS.IN_APP_PLUS_BUTTON,
    trigger: CHILI_PIPER_TRIGGERS.IN_APP_BUTTON,
  });

export const triggerChiliPiperForPlusPage = async (
  email: string,
  firstName: string,
  lastName: string,
): Promise<void> =>
  triggerChiliPiper({
    lead: { email, "First Name": firstName, "Last Name": lastName },
    router: CHILI_PIPER_ROUTERS.IN_APP_PLUS_PAGE,
    trigger: CHILI_PIPER_TRIGGERS.IN_APP_BUTTON,
  });
